export enum CallTypeEnum {
   CLOUD_CALLING = 'CLOUD_CALLING',
   DIRECT_CALLING = 'DIRECT_CALLING',
   NOT_ALLOWED = 'NOT_ALLOWED'
}

export enum FailedCallTypeEnum {
   ONLY_DND = 'ONLY_DND',
   ANY_ERROR = 'ANY_ERROR'
}

export interface CallingPermissions {
   hasCallingPermission: boolean
   callTypeEnum: CallTypeEnum | null
   failedCallTypeEnum: FailedCallTypeEnum | null
}

export interface ActivityPermissions {
   initiateLeadActivities: string[]
}

export type PluginType =
   | 'KNOWLARITY'
   | 'WATI'
   | 'GALLABOX'
   | 'GUPSHUP'
   | 'SMARTFLO'

export interface PipelineCustomization {
   enableActivities: boolean
   enableCalls: boolean
   enableSendWhatsAppMessages: boolean
   enableShareableResources: boolean
   enableTasks: boolean
   enableRecordScore: boolean
}

export interface PipelineFeaturesStatusType {
   isActivitiesEnabled: boolean
   isCallLogsEnabled: boolean
   isSendWhatsAppMessagesEnabled: boolean
   isShareableResourcesEnabled: boolean
   isTasksEnabled: boolean
   isRecordScoreEnabled: boolean
}

export interface AccountFeaturesStatusType {
   isAIChatSupportEnabled: boolean
   isContactsEnabled: boolean
   isDataCoPilotEnabled: boolean
   isSchedulingEnabled: boolean
   isGoogleCalendarIntegrationEnabled: boolean
   isFlowwSignEnabled: boolean
   isDocuSignEnabled: boolean
   isAttendanceTrackingEnabled: boolean
   isOfficerManagementEnabled: boolean
   isScrutinyKeyGenerationEnabled: boolean
}

export type USER_ROLE = 'PMU_OFFICER' | 'OFFICER' | 'ADMIN'
